<template>
  <div>
    <van-skeleton title animate :row="12" :round="true" :loading="loading_ske">
      <div class="titles">
        APP版本
        <Icon type="md-add-circle" class="add01" @click="onModel1"/>
      </div>
      <Table border ref="selection" :columns="columns7" :data="data6" :loading="loading"></Table>

      <Modal
        v-model="modal1"
        title="添加公告"
        :mask-closable="false"
        @on-ok="add"
        @on-cancel="bigON">
        <Input v-model="version">
          <span slot="prepend">版本号</span>
        </Input>
        <div class="mo01">
          <p class="mo02">整包更新：</p>
          <el-switch
            v-model="xz_zb"
            active-color="#13ce66"
            inactive-color="#ff4949"
            class="mo03">
          </el-switch>
          <p class="mo02 mo04">安卓提示：</p>
          <el-switch
            v-model="xz_and"
            active-color="#13ce66"
            inactive-color="#ff4949"
            class="mo03">
          </el-switch>
          <p class="mo02 mo04">苹果提示：</p>
          <el-switch
            v-model="xz_ios"
            active-color="#13ce66"
            inactive-color="#ff4949"
            class="mo03">
          </el-switch>
        </div>
      </Modal>
    </van-skeleton>
  </div>
</template>

<script>
  import httpApp from '@/api/app';
  export default {
    name: "version",
    data(){
      return {
        columns7: [
          {
            title: '版本号',
            key: 'version',
            render: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'person'
                  }
                }),
                h('strong', params.row.version)
              ]);
            }
          },
          {
            title: '整包更新',
            key: 'is_zb'
          },
          {
            title: '安卓更新',
            key: 'is_and'
          },
          {
            title: '苹果更新',
            key: 'is_ios'
          },
          {
            title: '提交时间',
            key: 'ctime'
          },
          {
            title: '操作',
            key: 'action',
            width: 120,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    icon:'ios-create-outline'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.edit(params.index)
                    }
                  }
                }, '编辑'),
              ]);
            }
          }
        ],
        data6: [],
        loading_ske:true,     //骨架屏显示
        loading:false,        //是否加载
        modal1:false,         //是否显示选择模块
        xzid:'',              //选中的ID
        version:'',           //版本号
        xz_zb: false,         //整包选择的状态
        xz_and:false,         //是否选择安卓提示
        xz_ios:false,         //是否选择苹果提示
        id:'',                //选择时的ID
      }
    },
    created() {
    },
    mounted() {
      var me = this;
      let user = JSON.parse(sessionStorage.getItem('user'));
      let data = {
        mobile:user.mobile,
        sign:user.sign,
        userId:user.userId
      }
      httpApp.verList(data).then(res => {
        me.data6 = res.data;
        console.log(me.data6);
        me.data6.forEach(function (item,index) {
          if (item.mandatoryUpdate == 0) {
            me.$set(item,'is_zb','热更新包');
          } else {
            me.$set(item,'is_zb','整包');
          }
          if (item.model == 0) {
            me.$set(item,'is_and','不提示');
          } else {
            me.$set(item,'is_and','提示');
          }
          if (item.isUpdateIos == 0) {
            me.$set(item,'is_ios','不提示');
          } else {
            me.$set(item,'is_ios','提示');
          }
        })
        me.loading_ske = false;
      })
    },
    methods:{
      bigON(){//关闭弹窗
        var me = this;
        me.version = '';
        me.xz_ios = false;
        me.xz_and = false;
        me.xz_zb = false;
        me.id = '';
      },
      onModel1(){
        var me = this;
        me.modal1 = true;
      },
      edit(index){//点击编辑版本
        var me = this;
        me.id = me.data6[index].id;
        me.version = me.data6[index].version;
        if (me.data6[index].mandatoryUpdate == 1) {
          me.xz_zb = true;
        }
        if (me.data6[index].model == 1) {
          me.xz_and = true;
        }
        if (me.data6[index].isUpdateIos == 1) {
          me.xz_ios = true;
        }
        me.modal1 = true;
      },
      add(){//添加新版本
        var me = this;
        me.$Loading.start();
        if (me.version == '') {
          me.$message.error('请输入版本号');
          me.$Loading.error();
          return false;
        }
        let is_zb;
        let is_and;
        let is_ios;
        if (me.xz_zb == true) {
          is_zb = 1;
        } else {
          is_zb = 0;
        }
        if (me.xz_and == true) {
          is_and = 1;
        } else {
          is_and = 0;
        }
        if (me.xz_ios == true) {
          is_ios = 1;
        } else {
          is_ios = 0;
        }
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          mobile:user.mobile,
          sign:user.sign,
          userId:user.userId,
          model:is_and,
          isUpdateIos:is_ios,
          mandatoryUpdate:is_zb,
          version:me.version,
          source:0
        }
        if (me.id != '') {
          data['id'] = me.id;
        }
        httpApp.updateappversion(data).then(res => {
          switch (res.code) {
            case '0000':
              let user = JSON.parse(sessionStorage.getItem('user'));
              let data = {
                mobile:user.mobile,
                sign:user.sign,
                userId:user.userId
              }
              httpApp.verList(data).then(res => {
                me.data6 = res.data;
                console.log(me.data6);
                me.data6.forEach(function (item,index) {
                  if (item.mandatoryUpdate == 0) {
                    me.$set(item,'is_zb','热更新包');
                  } else {
                    me.$set(item,'is_zb','整包');
                  }
                  if (item.model == 0) {
                    me.$set(item,'is_and','不提示');
                  } else {
                    me.$set(item,'is_and','提示');
                  }
                  if (item.isUpdateIos == 0) {
                    me.$set(item,'is_ios','不提示');
                  } else {
                    me.$set(item,'is_ios','提示');
                  }
                })
              })
              if (me.id != '') {
                me.$message.success('编辑成功');
              } else {
                me.$message.success('添加成功');
              }
              me.version = '';
              me.xz_ios = false;
              me.xz_and = false;
              me.xz_zb = false;
              me.id = '';
              me.$Loading.finish();
              break;
            case '1111':
              me.$message.error('编辑失败');
              me.$Loading.error();
              break;
          }
        })
      },
    }
  }
</script>

<style scoped>
@import "app.css";
</style>